import { useEffect, useState } from 'react';
import { Button, Flex, Steps } from 'antd';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

import { useTranslation } from 'react-i18next';

// services
import NotificationService from 'core/services/notification';

// components
import LanguageButton from 'components/language-button/language-button';
import Icon from 'utils/icon';
import PageTitle from 'components/title/title';

// styles
import styles from './register.module.scss';
import darkLogo from 'assets/images/logo-dark.svg';
import authService from 'core/services/auth';

function RegisterPage() {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const location = useLocation();

	const [currentState, setCurrentState] = useState<1 | 2 | 3>(1);

	useEffect(() => {
		if (location.pathname == '/register' || location.pathname.includes('otp')) setCurrentState(1);
		else if (location.pathname.includes('company')) setCurrentState(2);
		else if (location.pathname.includes('agreement')) setCurrentState(3);
	}, [location]);

	const onLogout = () => {
		authService.clearAuthData();
		navigate('/');
	};

	return (
		<>
			<PageTitle name={t('TITLE.REGISTER')} />

			<Flex vertical style={{ minHeight: '100vh', width: '100vw' }}>
				<motion.div
					initial={{ opacity: 0, transform: 'translateY(-100%)' }}
					animate={{ opacity: 1, transform: 'translateY(0%)' }}
					transition={{ duration: 0.5 }}>
					<header className="p-3 p-md-5 pb-md-0 d-flex justify-content-center align-items-center flex-wrap flex-md-nowrap gap-3 justify-content-md-between">
						<img style={{ width: 200 }} src={darkLogo} />

						<Flex gap={20} align="center">
							{currentState == 1 && (
								<Button color="danger" variant="filled" onClick={() => navigate('/')}>
									{t('COMMON.BACK')}
								</Button>
							)}

							<LanguageButton />

							{(location.pathname.includes('otp') ||
								location.pathname.includes('company') ||
								location.pathname.includes('plans') ||
								location.pathname.includes('agreement')) && (
								<Button type="default" danger onClick={onLogout}>
									<Icon name="logout" color="red" />
									{t('COMMON.LOGOUT')}
								</Button>
							)}
						</Flex>
					</header>
				</motion.div>

				<main className="mt-5 px-2 text-center">
					<motion.div
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{
							duration: 0.5,
						}}
						className="mb-4">
						<Steps
							className={styles.stepper}
							responsive={false}
							items={[
								{
									status: currentState === 1 ? 'process' : 'finish',
									icon: (
										<span className="iconFrame">
											<Icon name="register1" />
										</span>
									),
								},
								{
									status: currentState < 2 ? 'wait' : currentState == 2 ? 'process' : 'finish',
									icon: (
										<span className="iconFrame">
											<Icon name="register2" />
										</span>
									),
								},
								{
									status: currentState < 3 ? 'wait' : currentState == 3 ? 'process' : 'finish',
									icon: (
										<span className="iconFrame">
											<Icon name="register4" />
										</span>
									),
								},
							]}
						/>
					</motion.div>

					<Outlet />
				</main>

				<motion.div
					initial={{ opacity: 0, transform: 'translateY(20px)' }}
					animate={{ opacity: 1, transform: 'translateY(0px)' }}
					transition={{ delay: 1, duration: 0.5 }}>
					<footer className="p-3 text-center" style={{ marginTop: 50 }}>
						{t('COMMON.POWERED_BY')} <span className="fw-bold">{t('COMMON.TAKHAROJ_FINANCE')}</span> {new Date().getFullYear()}{' '}
						{t('COMMON.HEFTH_PLATFORM')}.
					</footer>
				</motion.div>
			</Flex>
		</>
	);
}

export default RegisterPage;
